import React from 'react'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'

function index() {
  return (
    <div>
      <SubPageBreadCrumbs />
      Taxation</div>
  )
}

export default index